import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

const initialState = {
  data: [],
  accounting : [],
  printing: [],
  loading: false,
  errorMessage: "",
};

// get notice
export const bussiness = createAsyncThunk(`services/company`, async () => {
  const response = await api.get("/services/");
  // console.log("res", response);
  return response.data;
});

export const accounting = createAsyncThunk(`services/accounting`, async () => {
  const response = await api.get("/accounting/");
  // console.log("res", response);
  return response.data;
});

export const printing = createAsyncThunk(`services/printing`, async () => {
  const response = await api.get("/design-and-printing/");
  // console.log("res", response);
  return response.data;
});





const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(bussiness.pending, (state) => {
        state.loading = true;
      })
      .addCase(bussiness.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.errorMessage = "";
      })
      .addCase(bussiness.rejected, (state, action) => {
        state.loading = false;
        // state.errorMessage = action.payload;
      })
      .addCase(accounting.pending, (state) => {
        state.loading = true;
      })
      .addCase(accounting.fulfilled, (state, action) => {
        state.loading = false;
        state.accounting = action.payload;
        state.errorMessage = "";
      })
      .addCase(accounting.rejected, (state, action) => {
        state.loading = false;
        // state.errorMessage = action.payload;
      })
      .addCase(printing.pending, (state) => {
        state.loading = true;
      })
      .addCase(printing.fulfilled, (state, action) => {
        state.loading = false;
        state.printing = action.payload;
        state.errorMessage = "";
      })
      .addCase(printing.rejected, (state, action) => {
        state.loading = false;
        // state.errorMessage = action.payload;
      })
  },
});

export default serviceSlice.reducer;
